<template>
  <el-dialog
    :title="`代课${defaultFormItemTeach.id ? '编辑' : '申请'}`"
    :visible.sync="dialogVisible"
    width="550px"
    @close="close"
    class="teach-edit"
  >
    <el-tabs v-model="checkTab">
      <el-tab-pane label="代课" name="base">
        <ly-form
          :defaultFormItem="defData"
          :formConfig="formConfig"
          :formKeys="formKeys"
          ref="lyForm"
          @change="inputChange"
        >
          <template v-slot:class_info>
            <div class="class-info" v-if="class_info.id">
              <span>{{ class_info.org_full_name }}</span>
              <span>{{ class_info.specialized_subject_full_name }}</span>
            </div>
          </template>
        </ly-form>
      </el-tab-pane>
      <!-- <el-tab-pane label="审核流程" name="flow"></el-tab-pane> -->
      <el-tab-pane label="附件内容" name="file">
        <img :src="`${baseUrl}/${attach}`" v-if="attach" width="400px" />
        <upload @successCBK="fileChange" accept=".jpg, .jpeg, .png, .gif, .bmp" ButtonText="附件上传" />
      </el-tab-pane>
    </el-tabs>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="saveTeach">{{ isOnlyRead ? '关闭' : '保存并提审' }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { Dialog, Tabs, TabPane } from 'element-ui';
import LyForm from '@/components/LyForm';
import Upload from '@/components/Upload';
import { teachBaseFormItem } from '@/utils/formConfig';
import { classApi } from '@/api';

export default {
  name: 'PersonalTeachDetail',
  components: {
    ElDialog: Dialog,
    LyForm,
    ElTabs: Tabs,
    ElTabPane: TabPane,
    Upload
  },
  props: {
    defaultFormItemTeach: {
      type: Object,
      default() {
        return {};
      }
    },
    isOnlyRead: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      dialogVisible: false,
      checkTab: 'base',
      formKeys: {},
      formConfig: {
        'label-width': '100px',
        'label-position': 'left',
        ref: 'ly-form',
        itemSpan: 24
      },
      class_info: {},
      attach: '',
      baseUrl: '',
      defData: {}
    };
  },
  mounted() {
    this.init();
  },
  watch: {
    defaultFormItemTeach() {
      if (this.defaultFormItemTeach.id) this.setDefData();
      else this.resetFormItem();
    }
  },
  methods: {
    init() {
      classApi.supplyTypeChoose().then(res => {
        if (res) {
          teachBaseFormItem.supply_type.options.radios = res.data;
          this.formKeys = teachBaseFormItem;
        }
      });
      // 获取多媒体信息地址
      this.$store.dispatch('app/getOssUrl').then(url => {
        this.baseUrl = url;
      });
    },
    resetFormItem() {
      this.class_info = {};
      this.attach = '';
      this.$nextTick(() => {
        this.$refs.lyForm.resetFields();
        this.defData = {};
      });
    },
    setDefData() {
      const tmp = { ...this.defaultFormItemTeach };
      tmp.supply_time = [tmp.supply_start_time, tmp.supply_end_time];
      this.defData = tmp;
      this.class_info = { ...this.defaultFormItemTeach };
    },
    fileChange(value) {
      this.attach = value[0].url;
    },
    inputChange(formData, key, obj) {
      if (obj && key === 'class_id' && obj.teacher) {
        this.class_info = { ...obj };
        // eslint-disable-next-line no-param-reassign
        formData.original_teacher_id = ''; // 重置请假老师
        this.formKeys.original_teacher_id.options.select = [...obj.teacher];
      } else if (!formData.class_id) {
        this.class_info = {};
      }
      // 自动计算课时数
      if (formData.supply_time && formData.supply_time.length && formData.class_id) {
        classApi
          .getSupplyClassCount({
            params: {
              class_id: formData.class_id,
              supply_start_time: formData.supply_time[0],
              supply_end_time: formData.supply_time[1]
            }
          })
          .then(res => {
            if (res && res.data) {
              // eslint-disable-next-line no-param-reassign
              formData.supply_class_count = res.data.supply_class_count;
            }
          });
      } else {
        // eslint-disable-next-line no-param-reassign
        formData.supply_class_count = '';
      }
    },
    async saveTeach() {
      const { data, valid } = await this.$refs.lyForm.getFormData();
      if (valid) {
        let res = null;
        if (this.defaultFormItemTeach.id) {
          res = await classApi.controlClassSupply({
            methold: 'put',
            id: this.defaultFormItemTeach.id,
            params: {
              ...data,
              supply_start_time: data.supply_time[0],
              supply_end_time: data.supply_time[1]
            }
          });
        } else {
          res = await classApi.classSupply({
            methold: 'post',
            params: {
              ...data,
              supply_start_time: data.supply_time[0],
              supply_end_time: data.supply_time[1]
            }
          });
        }
        if (res) {
          this.$message.success(res.msg || '提交成功！');
          this.dialogVisible = false;
          this.$emit('success');
        }
      }
    },
    openDg() {
      this.dialogVisible = true;
    },
    close() {
      this.dialogVisible = false;
      this.$refs.lyForm.resetFields();
    },
    handleRemove(file) {
      this.$refs.upload.abort(file);
    }
  }
};
</script>
<style lang="less">
.teach-edit {
  .el-dialog__body {
    padding: 10px 20px;
  }
  .el-input,
  .el-textarea {
    width: 400px;
  }
  .class-info {
    margin-left: 100px;
    > span {
      display: inline-block;
      padding: 0 20px;
      border: 1px solid @main-blue;
      margin-right: 20px;
      border-radius: 3px;
      margin-bottom: 2px;
    }
  }
}
</style>
